import { __rest } from "tslib";
import StarFilled from '@haier/icons/StarFilled';
import RcRate from 'rc-rate';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import Tooltip from '../tooltip';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
const Rate = React.forwardRef((props, ref) => {
    useBuriedPoint('Rate');
    const { prefixCls, tooltips, character = React.createElement(StarFilled, null) } = props, rest = __rest(props, ["prefixCls", "tooltips", "character"]);
    const characterRender = (node, { index }) => {
        if (!tooltips) {
            return node;
        }
        return React.createElement(Tooltip, { title: tooltips[index] }, node);
    };
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const ratePrefixCls = getPrefixCls('rate', prefixCls);
    return (React.createElement(RcRate, Object.assign({ ref: ref, character: character, characterRender: characterRender }, rest, { prefixCls: ratePrefixCls, direction: direction })));
});
if (process.env.NODE_ENV !== 'production') {
    Rate.displayName = 'Rate';
}
export default Rate;
